import './log/installGlobalHandlers';
import './globals.js';
import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './components/App';
import * as serviceWorker from './serviceWorker';
import './version.js';
import './useRDP.js';
import './index.css';
import { CoreUIProvider } from '@v2cloud/react';
import { getFlagValue, startFeatureFlags } from './feature_flags.js';
import axios from 'axios';
import packageInfo from '../package.json';
import { addEventSink } from './log';
import { buildEvent } from './log/clientEventSchema';
import { configureCorrelation, installCorrelationHeaders, isSameOrigin } from './log/correlation';
import { logged_in } from './auth.js';
import { startShipping } from './log/shipping';

// Before the feature flags: failures while they load, or a failed load, are shipped too.
startShipping({
  axios, addEventSink, buildEvent, webVersion: packageInfo.version, isSignedIn: () => !!logged_in.get(),
});

await startFeatureFlags();

// Same-origin requests (the desktop app's local proxy to Tokyo and Kyoto) always carry them.
// Cross-origin ones (the web build, the OAuth endpoints) need the servers' CORS to allow the
// headers, so they wait for a flag.
configureCorrelation(request => isSameOrigin(request.url, window.location.origin, request.baseURL || axios.defaults.baseURL)
  || getFlagValue('denver_correlation_headers'));
installCorrelationHeaders(axios);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CoreUIProvider>
      <App />
    </CoreUIProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();